/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { SysParamDto } from '../models/sys-param-dto';
import { sysParamGetAsDto } from '../fn/sys-param/sys-param-get-as-dto';
import { SysParamGetAsDto$Params } from '../fn/sys-param/sys-param-get-as-dto';

@Injectable({ providedIn: 'root' })
export class SysParamService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `sysParamGetAsDto()` */
  static readonly SysParamGetAsDtoPath = '/v1/SysParam/GetAsDTO';

  /**
   * Get Sysparam object (with SysParam name, value, group, ...),   Permissions [AuthenticatedUser|LIGHT_LOGIN_USER] ,   Restricted to [HOSPITAL|INSURER|ADMIN|KIOSK_HOME|KIOSK_ONLY].
   *
   * It will return the matching SysParam object on yours filter criteria
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sysParamGetAsDto()` instead.
   *
   * This method doesn't expect any request body.
   */
  sysParamGetAsDto$Response(params?: SysParamGetAsDto$Params, context?: HttpContext): Observable<StrictHttpResponse<SysParamDto>> {
    return sysParamGetAsDto(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Sysparam object (with SysParam name, value, group, ...),   Permissions [AuthenticatedUser|LIGHT_LOGIN_USER] ,   Restricted to [HOSPITAL|INSURER|ADMIN|KIOSK_HOME|KIOSK_ONLY].
   *
   * It will return the matching SysParam object on yours filter criteria
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sysParamGetAsDto$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sysParamGetAsDto(params?: SysParamGetAsDto$Params, context?: HttpContext): Observable<SysParamDto> {
    return this.sysParamGetAsDto$Response(params, context).pipe(
      map((r: StrictHttpResponse<SysParamDto>): SysParamDto => r.body)
    );
  }

}
